import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import './App.scss';
import Overall from './Overall';
import Touring from './Touring';
import Historic from './Historic';
import Endurance from './Endurance';
import Rounds from './Rounds';
import Videos from './Videos';
import aroc from './assets/img/aroc.png';

class App extends Component {

	render() {
		return (
			<div className="App">
				<div className="container px-2">

					<div className="flex content-center pt-4" id="header">
						<div className="col flex-grow self-center px-4">
							<h1><strong>AROC</strong> Bianco Motorsport Future Alfa Racer Championship 2020</h1>
						</div>
						<div className="col flex-shrink self-center px-4">
							<a href="https://www.aroc-uk.com/" target="_blank"><img src={aroc} alt="aroc" width="55" /></a>
						</div>
						<div className="col flex-shrink self-center px-4">
							<a href="https://alfaracer.com/" target="_blank"><img src="https://alfaracer.com/wp-content/themes/alfaracer/assets/svg/arca-logo.svg" alt="arca" width="120" /></a>
						</div>
					</div>

					<Tabs>
						<TabList>
							<Tab>Overall</Tab>
							<Tab className="touring">Touring</Tab>
							<Tab className="historic">Historic</Tab>
							<Tab className="endurance">Endurance</Tab>
							<Tab>Round by Round</Tab>
						</TabList>

						<TabPanel>
							<Overall/>
						</TabPanel>

						<TabPanel>
							<Touring/>
						</TabPanel>

						<TabPanel>
							<Historic/>
						</TabPanel>

						<TabPanel>
							<Endurance/>
						</TabPanel>

						<TabPanel>
							<Rounds/>
						</TabPanel>

						<TabPanel>
							<Videos/>
						</TabPanel>
					</Tabs>
				</div>
			</div>
		);
	}
}

export default App;
